import React, { useEffect, useState } from 'react';
import ModalFormClients from '../../components/forms/clients/modal.form.clients'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Button, Row, Col } from '@themesberg/react-bootstrap';
import { get, del } from '../../services/back.service';
import ModalMessage from '../../components/widgets/modalMessage';
import DownloadButton from '../../components/widgets/downloadButton';

function ListClients() {
  const [clientDelete, selectClientDelete] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [msgGet, setMsgGet] = useState('');
  const [clients, setClients] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getClients()
  }, []);

  const createClientsVehicle = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getClients()
  };

  const editButton = (row) => {
    return (
      <Row>
        <Col>
          <ModalFormClients
            title="Modificar Cliente"
            button_text="Editar"
            button_variant="outline-primary"
            clientSelect={row.id}
            callback={createClientsVehicle}
            packages={allPackages}
          ></ModalFormClients>
        </Col>
        <Col>
          <Button onClick={() => controlDelete(row.id)}>Eliminar</Button>
        </Col>
      </Row>
    );
  };

  const controlDelete = (id) => {
    setShowModal(true);
    selectClientDelete(id);
  }

  const deleteClient = async () => {
    await del('/client/delete/0' + clientDelete);
    await getClients();
    setShowModal(false);
  }

  const getClients = async () => {
    const responseClients = await get('/client/', {})
    if (responseClients.success) {
      setClients(responseClients.data.clients);
      setAllPackages(responseClients.data.all_packages);
    } else {
      setMsgGet(responseClients.message)
    }
  }


  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
      <ModalMessage
        title={'Advertencia'}
        text={`Una vez elimine el cliente no se podra recuperar, esta seguro?`}
        showProps={showModal}
        funcAccept={deleteClient}
        funcClose={() => setShowModal(false)}
      />
      <ModalFormClients
        title="Crear Cliente"
        button_text="Crear Cliente"
        button_variant="primary"
        callback={createClientsVehicle}
        packages={allPackages}
      ></ModalFormClients>
      <DownloadButton infoReport={clients} filename={'clientes.csv'} separator={';'} />
      <ListTables
        data={clients}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListClients;
